import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    // PIN is the sole credential. Login returns 204 with the bearer/refresh tokens in the
    // X-Token-Part / R-Key headers (plus split cookies); addTokenWriteInterceptor() persists them,
    // so a session is established exactly like password login. skipErrorHandler() lets this store own
    // the error toast; skipRefreshToken() because a fresh login must not attempt a refresh on 401.
    // The 204 has no body, so we read `me` for the authenticated user's id — the re-auth bridge
    // compares it against the pre-lock session to tell an unlock apart from a user switch.
    loginWithPin(pin: string): Observable<string> {
        return this.httpClient
            .skipRefreshToken()
            .skipErrorHandler()
            .addTokenWriteInterceptor()
            .post<void>('login', { pin })
            .pipe(
                switchMap(() => this.httpClient.skipErrorHandler().get<{ data: { id: string } }>('me')),
                map((response) => response.data.id),
            );
    }
}
